<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="getData"
    ></SiruiSearch>
    <div class="main-content">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <div class="public-table">
        <vxe-grid
          ref="weightRows"
          border
          resizable
          show-overflow
          size="mini"
          height="500"
          :load="loading"
          :show-footer="true"
          :data="tableData"
          :edit-rules="editRules"
          :footer-method="footerMethod"
          :edit-config="editConfig"
        >
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="firstIndexName" title="一级指标"></vxe-table-column>
          <vxe-table-column field="secondIndexName" title="二级指标"></vxe-table-column>
          <vxe-table-column field="thirdIndexName" title="三级指标"></vxe-table-column>
          <!--<vxe-table-column field="weight" title="权重（%）" :edit-render="{ name: '$input', autofocus: '.el-input__inner', immediate: true}" :formatter="formatter">-->
          <!--  <template v-slot:edit="{row}">-->
          <!--    <el-input type="number" v-model="row.weight" step="0.01"></el-input>-->
          <!--  </template>-->
          <!--</vxe-table-column>-->
          <vxe-table-column
            field="weight"
            title="权重（%）"
            :edit-render="{ name: 'input', immediate: true }"
            :formatter="formatter"
          ></vxe-table-column>
        </vxe-grid>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserCompanyList } from '@/common/js/util';
  import SiruiSearch from '@/components/SiruiSearch';
  import buttonItem from '../../../../components/ButtonItem';
  import { mapState } from 'vuex';
  export default {
    name: 'weightAllocation',
    components: {
      SiruiSearch,
      buttonItem,
    },
    data() {
      const nameValid = (rule, value, callback, { row }) => {
        let decimal = String(row.weight).split('.');
        if (decimal.length > 1) {
          if (decimal[1].length > 2) {
            callback(new Error('小数最多2位'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      return {
        tableData: [],
        loading: false,
        query: {
          companyCode: '',
        },
        menuButtonList: [],
        editRules: {
          test: [{ required: true, message: '性别必须填写' }],
          weight: [
            { validator: nameValid },
            { type: 'number', required: true, min: 0, max: 100, message: '请输入0至100数字' },
          ],
        },
        editConfig: {}, //控制是否可以编辑，点击编辑按钮才能编辑
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            type: 'select', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'companyCode',
            options: getUserCompanyList(),
          },
        ];
      },
    },
    mounted() {
      //获取默认公司
      this.query.companyCode = this.userInfo.companyCode;
      this.getButtonList();
      this.getData();
    },
    methods: {
      clickEvent(type) {
        if (type === 'edit') {
          this.edit();
        } else if (type === 'save') {
          this.save();
        }
      },
      edit() {
        //激活编辑状态
        this.editConfig = { trigger: 'click', mode: 'row' };
        this.loading = true;
        //获取最新数据
        this.$axios
          .post('/sales/creditLimitEngineWeight/listNew', { companyCode: this.query.companyCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.loading = false;
              //激活第一行编辑状态
              this.$nextTick(() => {
                this.$refs.weightRows.setActiveRow(
                  this.$refs.weightRows.getTableData().fullData[0]
                );
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      save() {
        let params = this.$refs.weightRows.getTableData().fullData;
        //将权重转为数字类型
        let total = 0;
        params.map((item) => {
          total += Number(item.weight);
          return (item.weight = Number(item.weight));
        });

        if (total !== 100) {
          this.$message({
            showClose: true,
            message: '权重合计需为100%',
            type: 'error',
          });
          return;
        }
        this.$refs.weightRows.validate((valid) => {
          if (valid) {
            this.$axios
              .post('/sales/creditLimitEngineWeight/save', params)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message({ showClose: true, type: 'success', message: '保存成功' });
                  this.getData();
                } else {
                  this.$message({ showClose: true, type: 'error', message: res.data.msg });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      },
      getData() {
        this.loading = true;
        this.editConfig = {};
        this.$axios
          .post('/sales/creditLimitEngineWeight/list', { companyCode: this.query.companyCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      resetBtnClick() {
        this.query.companyCode = this.userInfo.companyCode;
        this.getData();
      },
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e);
          this.menuButtonList = e;
        });
      },
      formatter({ cellValue }) {
        return cellValue + '%';
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            } else if (columnIndex === 4) {
              let total = 0;
              data.forEach((item) => {
                total += Number(item.weight);
              });
              return total + '%';
            }
          }),
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  .public-table {
    .el-input {
      width: 90%;
      margin-right: 10px;
    }
    ::v-deep .vxe-table .vxe-default-input:focus {
      border: 1px solid #00b400;
    }
  }
</style>
